import type { ReactNode } from "react";
import { SiteBuilderContent } from "./SiteBuilderContent";
import {
    siteBuilderFormForKey,
    siteBuilderPublishedFormItems,
    siteBuilderFormWithAuthoredPresentation,
} from "./siteBuilderForm";
import { TemplateLeadForm } from "./TemplateLeadForm";
import type {
    PageLink,
    ResolvedTemplateDesign,
    SiteBuilderContentJson,
    SiteInfo,
    SiteLeadForm,
    SitePageContent,
    TemplateLinkComponent,
    TemplateRenderProps,
} from "./types";

export function WebSiteBuilderContent({
    bookingDemoData,
    contentJson,
    design,
    editorMode = false,
    headerActions,
    leadForm,
    leadForms,
    LinkComponent,
    menus,
    navigationReadOnly,
    page,
    pages,
    readOnly,
    site,
}: {
    bookingDemoData?: boolean;
    contentJson: SiteBuilderContentJson | null | undefined;
    design: ResolvedTemplateDesign;
    editorMode?: boolean;
    headerActions?: ReactNode;
    leadForm?: SiteLeadForm | null;
    leadForms?: SiteLeadForm[];
    LinkComponent: TemplateLinkComponent;
    menus?: TemplateRenderProps["menus"];
    navigationReadOnly?: boolean;
    page: SitePageContent | null;
    pages: PageLink[];
    readOnly?: boolean;
    site: SiteInfo | null;
}) {
    const availableForms = leadForms && leadForms.length > 0
        ? leadForms
        : leadForm
            ? [leadForm]
            : [];

    return (
        <SiteBuilderContent
            bookingDemoData={bookingDemoData}
            contentJson={contentJson}
            design={design}
            editorMode={editorMode}
            headerActions={headerActions}
            LinkComponent={LinkComponent}
            menus={menus}
            navigationReadOnly={navigationReadOnly}
            page={page}
            pages={pages}
            readOnly={readOnly}
            renderForm={(formProps) => {
                const form = siteBuilderFormWithAuthoredPresentation(
                    siteBuilderFormForKey(
                        availableForms,
                        formProps.formKey,
                    ),
                    formProps.formBlock,
                );

                if (editorMode && !form) {
                    return null;
                }

                const publishedItems = siteBuilderPublishedFormItems(
                    form,
                    formProps.formBlock,
                );

                return (
                    <TemplateLeadForm
                        authoredItems={formProps.hasAuthoredItems
                            ? formProps.renderAuthoredItems(publishedItems.items)
                            : undefined}
                        buttonBackgroundColor={formProps.buttonBackgroundColor}
                        buttonTextColor={formProps.buttonTextColor}
                        columns={formProps.columns}
                        design={design}
                        fieldGap={formProps.fieldGap}
                        form={form}
                        formKey={formProps.formKey}
                        hasAuthoredSubmitButton={publishedItems.hasSubmitButton}
                        readOnly={formProps.readOnly}
                        submitLabel={formProps.submitLabel}
                        successMessage={formProps.successMessage}
                    />
                );
            }}
            site={site}
        />
    );
}
